module.exports = __webpack_public_path__ + "static/media/logo_ppdb_online_domsav.f3dc66db.png";